import { render, staticRenderFns } from "./SupportTicketTile.vue?vue&type=template&id=07c81e9a&scoped=true&"
import script from "./SupportTicketTile.vue?vue&type=script&lang=js&"
export * from "./SupportTicketTile.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketTile.vue?vue&type=style&index=0&id=07c81e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c81e9a",
  null
  
)

export default component.exports